import { render, staticRenderFns } from "./ChecklistSection.vue?vue&type=template&id=bc7a96a0"
import script from "./ChecklistSection.vue?vue&type=script&lang=js"
export * from "./ChecklistSection.vue?vue&type=script&lang=js"
import style0 from "./ChecklistSection.vue?vue&type=style&index=0&id=bc7a96a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports